import React from 'react';
import { defineBlock, useEditor, ChildrenBlock } from '@smartfire/gutenberg-react';
import { InnerBlocks } from '@wordpress/block-editor';
import clsx from 'clsx';
import style from './block.module.scss';

function Block() {
    const {isEditing} = useEditor();

    return (
        <div className={clsx(style.block, isEditing ? style.admin : style.front)}>
            {isEditing ?
                <InnerBlocks allowedBlocks={ ['smartfire/chiffres-pictos-item'] } />
                : <ChildrenBlock />    
            }
        </div>
    )
}

export default defineBlock({
    Block,
    setup: {
        title: 'Chiffres/pictos',
    }
})